import gql from 'graphql-tag';

import * as fragments from '../fragments';

export const FETCH_ALL_ANSWERS = gql`
  query AllAnswers {
    fetchAllAnswers {
      id
      body
      addedBy {
        ...identificationFields
      }
      comments {
        body
        commentedBy {
          ...identificationFields
        }
      }
      createdAt
      updatedAt
    }
  }

  ${fragments.IDENTIFICATION_FRAGMENT}
`;
